import React, { useEffect, useState } from 'react';
import classnames from "classnames";
import Styles from "../../styles.module.scss";
import { Icon } from '@iconify/react';
import LanguageForm from '../../../../dashboardFormComponents/langaugeForm';
import DeleteModal from '../../../../modals/deleteModal';
import { submitDetails, getDetails } from './services';
import NotificationAlert from "../../../../components/notification";
import mixpanelData from '../../../../utils/mixpanel';


interface Props {

    LanguageHandler: (event: any) => void
    getUserDetails: (event: any) => void
    defaultValues: {
        education: {degree: string, institution: string, startDate: number, endDate:number, action: string}[],
        language: {name: string, proficiency: string, action: string}[]
    },
    loginId: string | null ,
    displayNotification: (event: string) => void,
    englishProficiency: any
  
  }

  const Languages: React.FC<Props> = ({
    LanguageHandler,
    getUserDetails,
    displayNotification,
    englishProficiency,
    loginId,
    defaultValues
  }) => {
    
    const [defaultLanguages, setDefaultLanguages] = useState<{}[]>([])
    const [newLanguage, setNewLanguage] = useState<boolean>(false)
    // const [editLanguage, setEditLanguage] = useState<boolean>(false)
    const { v4: uuidv4 } = require('uuid');
    const [languagevisible, setLanguagevisible] = useState(true);
    const [visibleDeleteModal, setVisibleDeleteModal] = useState(true);
    const [section, setSection] = useState<string>('')
    const [languageIndex, setLanguageIndex] = useState<number>(-1)
    const [language, setLanguage] = useState<{languageId?: string, name: string, proficiency: string, action: string}[]>([]);
    const [notification, setNotification] = useState<boolean>(false)
    // const [message, setMessage] = useState<string>('')
    const [languageArray, setLanguageArray] = useState<any>([])
    
    defaultLanguages.pop()
    for(let i=0 ; i < (defaultValues.language ? defaultValues.language.length : 0) ; i++ )
    {
        if (!defaultLanguages.includes(defaultValues.language[i].name)) {
            defaultLanguages.push(defaultValues.language[i].name)
        }
           
    }
    
    
    useEffect(() => {
        
        if(englishProficiency !== undefined){
            setLanguageArray([])
            languageArray.push(englishProficiency)
        }
        if(defaultValues.language){
            const mergeArray = [...languageArray, ...defaultValues.language]
            setLanguage(mergeArray)  
        }else{
            setLanguage(languageArray)
        } 

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [defaultValues.language])

    const languageModal = () => {
        setLanguagevisible (!languagevisible);
        setLanguageIndex(-1)
        setNewLanguage(true)
    };

    const submitLanguage = (data: any) => {  
        setDefaultLanguages([])
        let value = {
            action: data.action,
            section: 'language',
            loginId: loginId,
            language:
            {
              languageId: data.languageId ? data.languageId : uuidv4(),
              name: data.name,
              proficiency: data.proficiency
            }
        }
        submitDetails(value).then((response) => {
            if( response && response.status === 1) {
                mixpanelData(data.action === 'add' ? 'MWP-Language submitted' : 'MWP-Language Updated', {
                    'distinct_id': response && response.data[0].profile_metadata.email,
                    'Email':response.data[0].profile_metadata.email,
                    'Language': data.name,
                    'proficiency': data.proficiency
                })
                mixpanelData(data.action === 'add' ? 'New MWP - Language submitted' : 'New MWP - Language updated', {
                    'distinct_id': response && response.data[0].profile_metadata.email,
                    'Candidate loginid': loginId,
                    'Candidate name': response.data[0].profile_metadata.firstName + ' ' +response.data[0].profile_metadata.lastName,
                    'Language': data.name,
                    'Proficiency': data.proficiency
                })
                languageModal();
                getDetails(loginId).then((resp) => {                                       
                    setLanguage(resp.data[0].profile_metadata.language)     
                    getUserDetails(loginId)  
                    displayNotification('Details saved successfully');    
                })
                onClose();
            }
            })
      }

      const deleteModal = () => {
        setVisibleDeleteModal(!visibleDeleteModal)
        setLanguageIndex(-1)
      }

      const Delete = (section: string) => {        
        let value = {}
            value = {
                "action": 'delete', 
                "section": 'language',
                "loginId": loginId,
                "language": {
                    "languageId":  language[languageIndex].languageId
              } 
        }
        
        submitDetails(value).then((response) => {
            
            if( response && response.status === 1) {
                mixpanelData('MWP-Language Deleted', {
                   'source': "freelancer deletes language details",
                   'Success':  true,
                   'Email': response.data[0].profile_metadata.email,
                   'distinct_id':response.data[0].profile_metadata.email,
                   'Language': language[languageIndex].name
                })
                mixpanelData('New MWP - Language deleted', {
                    'Candidate name': response.data[0].profile_metadata.firstName + ' ' +response.data[0].profile_metadata.lastName,
                    'distinct_id':response.data[0].profile_metadata.email,
                    'Candidate loginid': loginId,
                    'Language': language[languageIndex].name,
                    'Profiency': language[languageIndex].proficiency
                 })
                getDetails(loginId).then((resp) => {             
                    deleteModal();     
                    setLanguage(resp.data[0].profile_metadata.language)     
                    getUserDetails(loginId)  
                    displayNotification('Details deleted successfully')
                })
            }
        })
      }
      
      
      const onClose = () => {
            setNotification(false)
            setLanguageIndex(-1)
            setNewLanguage(false)
            // setEditLanguage(false)
           }



       return (
        <section>
             {notification && <NotificationAlert onClose={onClose } closable={true} >
               
             </NotificationAlert> }
             {!visibleDeleteModal && ( <DeleteModal onClose={deleteModal} onSubmit={Delete} section={section}/> )}
                
                {/* <Headline4>Academic Details</Headline4> */}
                { language && language.map((item, key) => {
                    return(
                        <div>
                            { key !== languageIndex ? <div className={Styles.workExpWrapper} key={key}>
                                <div className={classnames(Styles.workExpCard, Styles.eduExpCard)}>
                                    <div className={Styles.workExpHead}>
                                    <div>
                                    <h6>{item.name}</h6>
                                    <div className={Styles.expDate}>{item.proficiency}</div>
                                    </div>
                                        <div className={Styles.actions}>
                                            <Icon icon="lucide:edit-2" onClick={() => { setLanguageIndex(key)}}/>
                                            <Icon icon="mdi:trash-can-outline" onClick={() => { deleteModal(); setLanguageIndex(key); setSection('language')}} />
                                        </div>
                                    </div>
                                </div> 
                             </div> : <LanguageForm ClickHandler={submitLanguage} defaultLanguages={defaultLanguages} defaultValues={languageIndex !== -1 ? language[languageIndex] : ''} onClose={onClose} />}
                        </div>
                    )
                })}
                <div>
                { newLanguage ? <LanguageForm ClickHandler={submitLanguage} defaultLanguages={defaultLanguages}  defaultValues={languageIndex !== -1 ? language[languageIndex] : ''} onClose={onClose} />
                : <button className={Styles.addWorkHistory}  onClick={languageModal}><Icon icon="fluent:add-circle-28-regular" />Language</button> }
                </div>
            </section>
        );
}
export default Languages